import React from "react";
import { Box, Typography } from "@mui/material";
import useAppStore from "../../../stores/appStore";
import useUserStore from "../../../stores/userStore";

export const DomainFocusBlock: React.FC = () => {
  const { focus, domain } = useAppStore();
  const getFocusDisplayName = useUserStore((state) => state.getFocusDisplayName);
  const focusDisplayName = getFocusDisplayName(focus, domain);

  return (
    <Box>
      <Typography color="white">
        Domain: <span style={{ fontWeight: "bold" }}>{domain}</span>
      </Typography>
      <Typography color="white">
        Focus: <span style={{ fontWeight: "bold" }}>{focusDisplayName}</span>
      </Typography>
    </Box>
  );
};
